import {
  getScans,
  deleteScan,
  scanShow,
  updateScan,
  suspendAllScan,
  reloadScan,
  createScan,
  finishScan
} from '../../api/scansApi'
import { Message } from 'element-ui'
import {getReport, updateUser} from '../../api/users'
import router from '../../router'

const state = {
  scans: [],
  meta: {},
  scanShow: {
    logo_name: null
  },
  reportData: [],
  reportInfo: {},
}

const getters = {
  getScans: state => state.scans,
  getScansMeta: state => state.meta,
  getScanShow: state => state.scanShow,
  reportData: state => state.reportData,
  reportInfo: state => state.reportInfo,
}

const mutations = {
  SET_SCANS: (state, payload) => {
    state.scans = payload.data
    state.meta = payload.meta
  },
  SET_SCAN_SHOW: (state, payload) => {
    state.scanShow = payload
  },
  SET_REPORT: (state, payload) => {
    state.reportData = payload.reportData
    state.reportInfo = payload.reportInfo
  },

}

const actions = {
  getScans: ({commit}, params) => {
    getScans(params).then(resp => {
      commit('SET_SCANS', resp)
    }).catch(err => console.log(err))
  },

  deleteScan: ({dispatch}, id) => {
    deleteScan(id).then(r => {
      Message({
        message: 'Scan has been deleted',
        type: 'success',
        duration: 5 * 1000,
        showClose: true,
      })
    })
  },

  scanShow: ({commit, dispatch}, idScan) => {
    scanShow(idScan).then(r => {
      commit('SET_SCAN_SHOW', r.data)
    }).catch(err => {
      console.dir(err)
      if (err.response.status === 404) {
        console.log(router.push({name: 'not-found'}))
      }
    })
  },

  clearCurrentScan: ({commit}) => {
    commit('SET_SCAN_SHOW', { logo_name: '' } )
  },

  updateScans: ({commit}, payload) => {
    updateScan(payload).then(r => {
      console.log('r', r)
      Message({
        message: 'Data saved',
        type: 'success',
        duration: 5 * 1000,
      })
    }).catch(err => console.dir(err))
  },

  updateScan: async ({commit}, payload) => {
    try {
      const r = await updateScan(payload)
      Message({
        message: 'Scan data updated',
        type: 'success',
        duration: 5 * 1000,
        showClose: true,
      })
      return r
    } catch (err) {
      return err
    }
  },

  finishScan: async ({commit}, scanId) => {
    try {
      const response = await finishScan(scanId);
      Message({
        message: 'Scan finished',
        type: 'success',
        duration: 5 * 1000,
        showClose: true,
      })
      return response;
    } catch (error) {
      return error;
    }
  },

  suspendUnfinishedScan: ({
                         commit
                       }) => {
    suspendAllScan().then(r => {
      console.log('r', r)
      Message({
        message:  'Finishing completed',
        type: 'success',
        duration: 5 * 1000,
      })
    }).catch(err => console.dir(err))
  },

  reloadScan: async ({
                       commit
                     }, pl) => {

    try {
      console.log(commit, pl)

      const r = await reloadScan(pl)
      Message({
        message: 'Reload scan data started',
        type: 'success',
        duration: 5 * 1000,
        showClose: true,
      })
      return r
    } catch (err) {
      console.log(err)
      return err
    }
  },

  createScan: ({commit}, payload) => {
    return new Promise((resolve, reject)=>{
      createScan(payload).then(resp => {
        resolve(resp)
      }).catch(err=> reject(err))
    })

      .catch(err => console.dir(err))
  },

  getReport: ({
                commit
              }, choiseReport) => {
    console.log(commit, choiseReport)
    getReport(choiseReport.id).then(r => {
      commit('SET_REPORT', {
        reportData: r.data,
        reportInfo: choiseReport,
      })
    }).catch(err => console.dir(err))
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
